import { GrpcWebFetchTransport } from '@protobuf-ts/grpcweb-transport';

const AUTH_STATUS = {
    0: 'AUTH_GUEST',
    1: 'AUTH_SIGN_IN',
    2: 'AUTH_SIGN_UP',
};
const REFERRAL_STATUS = {
    0: 'REFERRAL_UNKNOWN',
    1: 'REFERRAL_WRONG_LINK',
    2: 'REFERRAL_BUSY',
    3: 'REFERRAL_EXISTS',
};

export const projectIdWalletConnect = '024709ec0f5c1243961d1a12c735fb5b';

const transport = new GrpcWebFetchTransport({ baseUrl: import.meta.env.VITE_API_URL });
export { AUTH_STATUS, REFERRAL_STATUS, transport };
